export default function() {
	$("#forgotPasswordModal")
		.on('hide.bs.modal', function(e) {
			e.preventDefault();
			window.location = '/';
		})
		.modal('show');
};
